import { combineReducers } from 'redux';

import dashboard from './dashboard';
import details from './details';

export default combineReducers({
  details,
  dashboard,
});
